import { useCallback, useState } from "react";
import moment from "moment";
import { DespesaQuery } from "features/relatorios/typings";

const defaultFiltro: Partial<DespesaQuery> = {
  search: "",
  page: 1,
  limit: 10,
  contaBancariaIds: [],
  centrosDeCustoIds: [],
  categoriaIds: [],
  pago: undefined,
  dataFim: moment().endOf("month").format("YYYY-MM-DD"),
  dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  tipoData: "vencimento",
  pessoaId: undefined,
  rateioFechamentoId: undefined,
};

function useFiltroRelatorioDespesas() {
  const [filtro, setFiltro] = useState<DespesaQuery>(defaultFiltro);

  const onChangeFiltro = useCallback((_filtro?: Partial<DespesaQuery>) => {
    if (_filtro === undefined) {
      setFiltro(defaultFiltro);
    } else {
      setFiltro((state) => ({ ...state, ..._filtro }));
    }
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroRelatorioDespesas;
